import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "span" }) => {
  const Tag = motion[as] || motion.span;
  return (
    <span className="block overflow-hidden">
      <Tag
        className={`block ${className}`}
        initial={{ y: "112%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </Tag>
    </span>
  );
};

export const FadeIn = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
